import React, { useState } from 'react';
import { Transition } from '@headlessui/react';
import { useLockedBody } from 'usehooks-ts';
import cx from 'classnames';
import MainPopup from '@app/components/molecules/modal/popup/MainPopup';
// import MainImagePopup from '@app/components/molecules/modal/popup/MainImagePopup';
import { useTranslation } from 'react-i18next';

/**
 *
 * @property {()=> void} onClose
 * @property {boolean} timeClose
 */
const MainModal = ({
  onClose = () => console.log('close modal'),
  timeClose = false,
  children,
  bgOpacity = 70,
  idx = 0,
  content,
  left = 0,
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isChecked, setIsChecked] = useState(false);
  const { t } = useTranslation();

  const closeModal = () => {
    setIsOpen(false);
    onClose(isChecked, idx);
  };

  const onClickNoShow = () => {
    setIsChecked(!isChecked);
    setIsOpen(false);
    onClose(true, idx);
  };

  useLockedBody(isOpen);
  return (
    <Transition
      show={isOpen}
      className="fixed z-[100] inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <Transition.Child
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          className={`fixed inset-0 bg-black bg-opacity-${bgOpacity} transition-opacity"`}
          aria-hidden="true"
          onClick={closeModal}
        />
        <div className={`bg-opacity-0`}></div>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>
        <Transition.Child
          enter="ease-out duration-300"
          enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enterTo="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 translate-y-0 sm:scale-100"
          leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          className="relative inline-block align-bottom overflow-hidden shadow-xl transform transition-all sm:align-middle sm:max-w-[435px] sm:w-full my-[80px] mx-[10px]"
          style={{ left: `${left}px` }}
        >
          <button
            className="absolute top-[20px] right-[17px] z-20"
            onClick={closeModal}
          >
            <i className="icon-close text-black text-[18px]"></i>
          </button>
          <div>
            {children}

            {/* {content.type === 'text' && ( */}
            <MainPopup content={content} onClose={closeModal} />
            {/* )}
            {content.type === 'image' && (
                <MainImagePopup content={content}/>
            )} */}
          </div>
          {timeClose && (
            <div className="absolute left-0 bottom-0 py-[14px] px-[20px] w-full bg-white">
              <label className="flex items-center gap-x-[6px] text-[#9ba0a8] leading-none">
                <input
                  id="label"
                  type="checkbox"
                  value={isChecked}
                  onChange={() => onClickNoShow()}
                />
                <span>{t('오늘 하루 보지 않기')}</span>
              </label>
            </div>
          )}
        </Transition.Child>
      </div>
    </Transition>
  );
};

export default MainModal;
